import { NgModule, APP_INITIALIZER } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppLoadService } from './app-load.service';
import { SharedModule } from '@shared/shared.module';
import { firstValueFrom } from 'rxjs';
import { kzTimed } from '@shared/util/kz-perf';


export function preLoadApplicationBaseState(appLoadService: AppLoadService) {

  return  () => kzTimed('base-state', () => firstValueFrom(appLoadService.preLoadApplicationBaseState(), { defaultValue: null }));
  // return () => appLoadService.preLoadApplicationBaseState().toPromise();
}

/**
 * Restore the auth session from Firebase before bootstrap completes so the
 * NGXS AuthState is populated BEFORE any route guard (AuthGuard) runs.
 */
export function restoreAuthSession(appLoadService: AppLoadService) {
  return () => kzTimed('session', () => firstValueFrom(appLoadService.restoreAuthSession(), { defaultValue: null }));
}


export function preLoadLookupData(appLoadService: AppLoadService) {
  return  () => firstValueFrom(appLoadService.preLoadLookupData(), { defaultValue: null });
}


// export function preLoadTags(appLoadService: AppLoadService) {
//   return () =>
//     appLoadService
//       .preLoadTags()
//      // .pipe(take(1))
//       .pipe(first())
//       .toPromise();
// }

/**
 * @see{@link https://www.intertech.com/Blog/angular-4-tutorial-run-code-during-app-initialization/ }
 */
@NgModule({ imports: [SharedModule], providers: [
        AppLoadService,
        // { provide: APP_INITIALIZER, useFactory: preLoadMasterTenantInfo, deps: [AppLoadService], multi: true },
        { provide: APP_INITIALIZER, useFactory: restoreAuthSession, deps: [AppLoadService], multi: true },
        { provide: APP_INITIALIZER, useFactory: preLoadApplicationBaseState, deps: [AppLoadService], multi: true },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppLoadModule {}
